import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: true,
};


export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { setSidebarIsOpen, toggleSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;